import { useEffect, useState } from "react";
import { getBestSellerBanner } from "../services/products.service";

export default function useBestsellerBanner() {
  const [banner, setBanner] = useState(null);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBanner = async () => {
      setStatus("loading");
      try {
        const data = await getBestSellerBanner();
        setBanner(data || null); // Ensure fallback if no data
        setStatus("succeeded");
      } catch (err) {
        console.error("Bestseller banner fetch error:", err);
        setError(err);
        setStatus("failed");
      }
    };

    fetchBanner();
  }, []);

  return { banner, status, error };
}